import {PureComponent} from 'react'
import {TimeOffset} from "../../../../helpers/TimeHelper";

class LoginButton extends PureComponent {
    getSocialLoginForm = values => {
        return {
            email: values.email,
            name: values.name,
            user_time_offset: TimeOffset(),
            provider: values.provider,
            access_token: values.access_token,
            social_id: values.social_id,
            additional_data: values.additional_data,
        };
    };
}

export default LoginButton